<script>
  import { Pie } from 'vue-chartjs'

  export default {
    name: "ChartPie",
    extends: Pie,
    data () {
      return {
        chartData: {
          labels: [],
          datasets: [{
            borderWidth: 1,
            borderColor: [],
            backgroundColor: [],
            data: []
          }]
        },
        options: {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.chartCreate();
    },
    props : {
      chart : Object
    },
    methods : {
      chartCreate: function() {
        this.chartData.labels = this.chart.labels;
        this.chartData.datasets = this.createDatasets(this.chart.data);
        this.renderChart(this.chartData, this.options)
      },
      createDatasets : function(data){

        let datasets = [{
          borderWidth: 1,
          borderColor: [],
          backgroundColor: [],
          data: data
        }];
        
        for (let i = 0 ; i < data.length ; i++){
          datasets[0].borderColor.push(this.getRGBColor(i));
          datasets[0].backgroundColor.push(this.getRGBColor(i));
        }

        return datasets;

      },
      getRGBColor : function(i){
        const RGB = [(100 + i*50)*(100 + i*50) % 255, (100 - i*25)*(100 - i*25) % 255, (100 + i*25 + i*25) % 255];
        return 'rgba(' + RGB.join(",") + ', 0.2)';
      }
    }
  }
</script>